export const EXTERNAL_PROFILE_SHARE: { [key: number]: string } = {
    53: "Do not share with ENS",
}